const actions = {
  SET_STATE: 'claim/SET_STATE',
  CREATE_CLAIM: 'claim/CREATE_CLAIM',
  EDIT_CLAIM: 'claim/EDIT_CLAIM',
  DELETE_CLAIM: 'claim/DELETE_CLAIM',
}

export default actions
